export const NotFoundPage = () => {
  return <div>404 | Page not found</div>;
};
